var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('b-form',{ref:"bookingPositionForm",attrs:{"autocomplete":"off","novalidate":""},on:{"submit":function($event){handleSubmit(function () { return _vm.submit($event); })}}},[_c('BookingPositionNative',{attrs:{"position":_vm.position,"booking":_vm.booking}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }